<template>
    <div class="employee-notes">
        <div v-for="note in notes" class="uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right employee-notes-row">
            <pre>{{ note.content }}</pre>
            <div class="by-line">
	            -- <span v-if="note.from_user"> {{ note.from_user.name }},</span>
	            <a v-if="note.placement && note.placement.requisition" :href="'/requisitions/view/' + note.placement.requisition.id " target="_blank">{{ note.placement.requisition.name }}</a>
	            <span v-if="note.placement && note.placement.job">({{ note.placement.job.name }})</span>
            </div>
        </div>
	    <div v-if="notes.length == 0" class="uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right employee-notes-row">
		    No notes in ratings for this employee.
	    </div>
    </div>
</template>

<script>
    export default {
        name: "EmployeeRatingNotes",

        props:{
            uid:Number,
            deleteModalId:String,
            deleteFormRef:String
        },

        data(){
            return {
                notes:[],
            };
        },

        mounted(){
            this.loadNotes();
        },

        methods:{
            loadNotes(){
                this.note = "";
                axios.get("/api/rating/employee/"+this.uid+"/notes", {sort:"created_at",dir:"desc"})
                    .then((pack) => this.updateList(pack));
            },
            updateList(pack){
                this.notes = pack.data.data;
            },
            startSearch(){
                this.loadNotes();
            },
            activateDeleteModal(id){
                this.$root.$refs[this.deleteFormRef].loadForm(id);
            }
        }
    }
</script>

<style scoped>

</style>
